import { raygun } from '@ynap/clientside-monitoring'

export function isRiskifiedAvailable() {
    return typeof window !== 'undefined' ? window.RISKX : false
}

export function routerTrackEvent(history) {
    history.listen((location) => {
        const riskified = isRiskifiedAvailable()
        try {
            if (riskified) {
                riskified.go(location.pathname)
            } else {
                throw new Error('Failed in riskified routerTrackEvent. Riskified beacon is not loaded in the DOM')
            }
        } catch (error) {
            raygun.helpers.agent('send', {
                error,
                tags: ['Riskified', 'riskified-routerTrackEvent'],
                customData: {
                    DOMreadyState: document.readyState,
                },
            })
        }
    })
}
